import React, { useState } from 'react';
import axios from 'axios';
import { message, Row, Col, Layout, Form, Button, Input, Typography } from 'antd';
import { getApiHost, getAppSecure } from '~/common/utils';
import { logoutImpersonator, setImpersonatedCoachToken, currentImpersonatorToken } from '~/common/auth';

const { Title } = Typography;

export default (_) => {
  const [email, setEmail] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = () => {
    setIsLoading(true)
    const url =  getAppSecure('naluri') + getApiHost() + `/api/expert/impersonation/${email}`
    axios.get(url, {
      headers: { 'Authorization': `Bearer ${currentImpersonatorToken()}` }
    }).then((response) => {
      if (response.data.impersonated_coach_token) {
        setImpersonatedCoachToken(response.data.impersonated_coach_token)

        // We redirect to Root.js, which will check if we have impersonator
        // token.
        //
        // If yes, we are redirected to home/DefaultPage.js, which will check
        // if we have impersonator and impersonated coach token. If we have
        // both, it will login as coach as usual.
        window.location.href = "/";
      }

    }).catch((error) => {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message)
      }

      setIsLoading(false)
    })
  }

  return (
    <Layout style={{minHeight: "100vh"}}>
      <Layout.Content
        style={{display: 'flex',  justifyContent: 'center', flexDirection: 'column', minHeight: '100vh', minWidth: '100vw'}}
      >
        <Row justify="center">
          <Col span={12}>
            <Title level={4}>Choose the coach you want to impersonate: </Title>
            <Form
              name="impersonationOption"
              layout="vertical"
              onFinish={handleSubmit}>
              <Form.Item
                label="Coach Email to impersonate"
                name="email"
                rules={[{required: true}]}>

                <Input
                  name="email"
                  type="text"
                  placeholder=""
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </Form.Item>

              <Form.Item>
                <Button
                  loading={isLoading}
                  type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={12}>
            <Button
              onClick={() => {
                logoutImpersonator()
                window.location.href = "/"
              }}>
              Logout
            </Button>
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  )
}




// WEBPACK FOOTER //
// ./src/pages/ImpersonationOption.js